import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Tooltip, Paper, Badge, FormControlLabel, Checkbox, FormControl, Select, OutlinedInput, TextField, Button } from '@material-ui/core';
import MaterialTable from 'material-table';
import { AttachFile, DeleteOutlineOutlined as DeleteIcon, ShoppingCart as CartIcon,  Sync as SyncIcon, PriorityHigh, Search as SearchIcon, Clear as ClearIcon, AttachMoney, AddBoxRounded} from '@material-ui/icons';

import Awb from '../../../models/Awb';
import { UserRoleType } from '../../../models/User';
import Moment from 'moment';

import { formatCurrency } from '../../../utils/currencyFormatter';

import awbStyles from './awbs.module.css';
import forwarderStyles from '../../forwarderHeader/forwarderHeader.module.css';
import style from '../../gha/manageOrders/pickupOrderAwbsList/poAwbList.module.css';
import commonStyles from '../../common/common.module.css';
import orderNumberSearchStyles from '../../common/orderNumberSearch.module.css';
import fwdStyle from '../../forwarderPickupOrder/fwdOrders/fwdOrdersTable.module.css';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';


const iconFontSize = 20;
const PADDING_RIGHT = '14px';

const sortArr = [
  {
    value: 'creation_date',
    label:'Order Creation Date'
  },
  {
    value: 'arrival_date',
    label: 'Latest Arrival Date'
  },
  {
    value: 'prefix',
    label: 'Airwaybill Prefix'
  }
]
const statuses = [
  { 
    value: 'all', 
    label: 'All' 
  },
  { 
    value: 'paid',
    label: 'Shipments Paid For' 
  },
  { 
    value: 'unpaid', 
    label: 'Shipments Pending Payment' 
  }
];

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    priorityHigh: {
      color: '#FF0000',
      fontSize: '15px'
    },
    awbFilters: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  });

interface AwbsProps {
  classes: any;
  awbs: Awb[];
  openParts: Function;
  deleteAwb: Function;
  enableCartIcon: Function;
  checkAirwayBillIsInTheCart: Function;
  checkTotalPcsAndWgt: Function;
  onSyncClick: Function;
  openAttachments: (awbCode: string, awbNumber: string, version: number) => void;
  handleOpenPoD: (code: string, number: string, version: number) => void;
  userRole: UserRoleType;
  applyStorage: (code: string, number: string) => void;
  editAwb: boolean;
  completed: boolean;
  completeAwbs: (type: string) => void;
  awbNumber: string;
  searchAwb: Function;
  onChange: Function;
  handleStatusChange: (type: string, event: any) => void;
  sortValue: string;
  filterValue: string;
  openPayments: Function;
  openPaymentModal: Function;
  paid: boolean;
  unpaid: boolean;
  clearAwb: Function;
};

const Awbs = (props: AwbsProps) => {

  const { classes } = props;
  let textFieldClass: string = '';
  const sortOptions: Array<JSX.Element> = sortArr.map((val: {value: string, label: string} , index: number) => (
    <option key={ index } value={ val.value }>{ val.label }</option>
  ));

  const statusOptions = statuses.map((status, index) => (
    <option key={index} value={status.value}>{status.label}</option>
  ));

  return (
    <div className={`${ commonStyles.wrapper } ${ awbStyles.wrapper } ${ awbStyles.awbTbl }`}>
      <h3 className={commonStyles.header}> AWB Details</h3>
      { props.userRole == UserRoleType.FORWARDER && <div className={ classes.awbFilters }>
        <div>
          <small className={commonStyles.pr1}>Show:</small>
          <FormControlLabel
            value=""
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary"/>}
                checkedIcon={<CheckBoxIcon color="primary"/>}
                classes={{
                  root: classes.checkbox,
                }}
                onChange={ () => props.completeAwbs('complete') } 
                checked={ props.completed }
              />
            }
            label={'Shipments Delivered'}
            className={classes.completeLabel}
          />
        </div>
        
        <div className={[orderNumberSearchStyles.textField, orderNumberSearchStyles.flexAndRow, orderNumberSearchStyles.justContentSpaceBetween, fwdStyle.fwdSearchField, commonStyles.positionRelative].join(' ')} >
          <TextField
            value={ props.awbNumber }
            variant="outlined"
            onChange={(e) => props.onChange('awb', e)}
            className={ commonStyles.searchWrapper }
            InputProps={{
              className: [textFieldClass, commonStyles.searchIpField].join(' '),
              classes: { input: classes.inputSize }
            }}
            InputLabelProps={{ className: [textFieldClass, classes.textFieldLabel].join(' ') }}
            placeholder= 'Search AWB'
          />

          <Button
            color="primary"
            variant="contained"
            onClick={ () => props.searchAwb() }
            className={ commonStyles.searchBtn }

          >
            <SearchIcon
              className={`${ commonStyles.iconSearch } ${ commonStyles.mb3 }`}/>
          </Button>
          { props.awbNumber && <Button
            color="primary"
            variant="contained"
            onClick={ () => props.clearAwb() }
            className={ commonStyles.cancelBtn }

          >
            <ClearIcon
              className={`${ commonStyles.iconSearch } ${ commonStyles.mb3 }`}/>
          </Button> }
        </div>
        
        <div className={ commonStyles.dFlex }>
          <div className={ commonStyles.pr3 }>
            <small className={ commonStyles.pr1 }>Filter List For: </small>
            <FormControl className={ forwarderStyles.formControl } >
              <Select native
                onChange={(e) => props.handleStatusChange('filter', e) }
                value={ props.filterValue }
                inputProps={{
                  name: 'status',
                  id: 'status',
                }}
                className={ forwarderStyles.selectIp }
                input={ <OutlinedInput labelWidth={ 0 }  /> }
              >
              { statusOptions }
              </Select>
            </FormControl>
          </div>
          <div>
            <small className={ commonStyles.pr1 }>Sort List By: </small>
            <FormControl className={ forwarderStyles.formControl } >
              <Select native
                onChange={(e) => props.onChange('sort', e)}
                value={ props.sortValue }
                inputProps={{
                  name: 'port',
                  id: 'port',
                }}
                className={ forwarderStyles.selectIp }
                input={ <OutlinedInput labelWidth={ 0 }  /> }
              >
                { sortOptions }
              </Select>
            </FormControl>
          </div>
        </div> 
      </div> }
      <MaterialTable

        components={{Container: props => <Paper {...props} elevation={0} className={ `${commonStyles.paperTable} ${awbStyles.noPrint}` }/>}}

        columns = {[
          { title: 'Airwaybill', field: '', cellStyle: { width:'110px' },
            render: (rowData: Awb) => {

              return <span className={ awbStyles.awbCell } onClick= { () => { props.openParts(rowData) } }>{ rowData.code }-{ rowData.number }</span>;
            }
          },
          { title: 'Origin', field: 'origin' },
          { title: 'Flight Number', field: '', cellStyle: { width: '110px'}, headerStyle: { paddingRight: 0 },
            render: (rowData: Awb) => {
              let flightNo = rowData.import_parts[0] ? rowData.import_parts[0].flight_no : '';
              const isValid: boolean = props.checkTotalPcsAndWgt(rowData.pieces, rowData.weight, rowData.import_parts);
              const Attention: JSX.Element | null = isValid ? <PriorityHigh className={ classes.priorityHigh }/> : null;
              let flightDate: string = rowData.import_parts[0] ? Moment(rowData.import_parts[0].flight_date).format('DDMMM').toUpperCase() : '';
              if(rowData.import_parts.length > 1) {
                rowData.import_parts.forEach(part => {
                  flightDate =  part.added ? Moment(part.flight_date).format('DDMMM').toUpperCase() : flightDate;
                  flightNo = part.added ? part.flight_no : flightNo;
                });
              }
              const flightNumber: string = rowData.import_parts ?  `${ flightNo }/${ flightDate }` : '';

              return <span>
                <span >{ flightNumber }</span>
                <span className={ awbStyles.attention }>{ Attention }</span>
              </span>;
            }
          },
          { title: 'Latest Arrival Date', field: 'arrival_date', cellStyle: { paddingRight: PADDING_RIGHT, width:'80px' }, headerStyle: { paddingRight: '10px' },
            render: (rowData: Awb) => {
              let arrivalDate: string = rowData.arrival_date ? Moment(rowData.arrival_date).format('DD-MMM-YY').toUpperCase() : '';

              if(rowData.import_parts.length > 1) {
                rowData.import_parts.forEach(part => {
                  let arrDate = part.added ? part.arrival_date : rowData.arrival_date ? rowData.arrival_date : '';
                  arrDate = part.added && part.arrival_date > arrDate ? part.arrival_date : arrDate;
                  arrivalDate =  part.added ? Moment(arrDate).format('DD-MMM-YY').toUpperCase() : arrivalDate;
                });
              }
              return <span>{ arrivalDate }</span>;
            }
          },
          { title: 'Pcs', field: 'pieces', render: (rowData: Awb) => {
              let pieces = rowData.pieces;
              let cartPcs = 0;
              if(rowData.import_parts.length > 0) {
                rowData.import_parts.forEach(pcs => {
                  if(pcs.added && pcs.cart && !pcs.in_order) {
                    cartPcs += pcs.pieces;
                  }
                });
              }
              return <span className={ awbStyles.awbCell } onClick={ () => { props.openParts(rowData) } }>{ cartPcs != 0 ? `${cartPcs} of ${pieces}`: pieces }</span>;
            }},
          { title: 'Wgt', field: 'weight',
            render: (rowData: Awb) => {

              const weight: number = +(rowData.weight);
              let cartWeight = 0;
              if(rowData.import_parts.length > 1) {
                rowData.import_parts.forEach(pcs => {
                  if(pcs.added && pcs.cart && !pcs.in_order) {
                    cartWeight += Number(pcs.weight);
                  }
                })
              }
              return <span>{ cartWeight != 0 ? cartWeight : weight.toFixed(1) }K</span>;
            }
          },
          { title: 'Due', field: '', type: 'currency', cellStyle: { textAlign: 'left'}, headerStyle: {textAlign: 'left'} ,
            render: (rowData: Awb) => {
              return formatCurrency(rowData.due, 2, '$');
            }
          },
          { title: 'Latest Status', field: 'status', cellStyle: { paddingRight: PADDING_RIGHT },
            render: (rowData: Awb) => {
              if (rowData.status === 'SHIPMENT DELIVERED' || rowData.status === 'SHIPMENT PARTIALLY DELIVERED') {
                return (
                  <span>
                    <span>{ rowData.status }</span>
                    <span className={ awbStyles.poD } onClick={ () => props.handleOpenPoD(rowData.code , rowData.number, rowData.version) }>PoD</span>
                  </span>
                )
              }
              return (
                <span>{ rowData.status }</span>
              )
            }
          },
          { title: 'Add Payment', field: '', hidden: (props.userRole === 'gha'), cellStyle: { paddingTop: '10px', textAlign: 'center', paddingRight: PADDING_RIGHT }, headerStyle: {  paddingRight: PADDING_RIGHT, textAlign: 'center' },
            render: (rowData: Awb) => {

              return <Tooltip title="Add payments">
                {rowData.order_forwarder && rowData.status !== 'SHIPMENT DELIVERED' ?
                  <AddBoxRounded onClick={() => props.openPaymentModal(rowData)} className={`${ classes.iconFs } ${ classes.addBox }`} />
                  : <AddBoxRounded className={`${ classes.iconFs } ${ classes.disabledIcon }`} />
                }</Tooltip>;
            }
          },
          {
            title: 'Apply Storage', field: '', hidden: props.userRole === 'fwd', cellStyle: { textAlign: 'center'}, headerStyle: { textAlign: 'center'},
            render: (rowData: Awb) => {
              return (
                <FormControlLabel
                  value={ rowData.storage }
                  defaultChecked={ true }
                  control={
                    <Checkbox
                      onChange={ () => props.applyStorage(rowData.code, rowData.number) }
                      checked={ rowData.storage === undefined ? false : rowData.storage }
                      color="primary"
                      defaultChecked={ true }
                      disabled={ rowData.import_parts.length < 2 }
                    />
                  }
                  label={""}
                />)
            }
          },
          { title: 'Action', headerStyle: { textAlign: 'center' },
            render: (rowData: Awb) => {

              return <span className={ style.awbActionsList } >
                <Tooltip title="Attach file">
                  <span>
                    <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachments_count }>
                      <AttachFile className={ classes.materialIcon } onClick={(events) => props.openAttachments(rowData.code, rowData.number, rowData.version) } />
                    </Badge>
                  </span>

                </Tooltip>
                { props.userRole === UserRoleType.FORWARDER && 
                  <Tooltip title="View Receipt">
                    { rowData.order_forwarder
                      ? ( <AttachMoney className={ classes.materialIcon } onClick={() => props.openPayments(rowData)} />)
                      : ( <AttachMoney className={ classes.disabledIcon } /> )
                    }
                  </Tooltip>
                }
                <Tooltip title="Add to cart">
                  { props.enableCartIcon(rowData.number, rowData.code) && rowData.allowed_ops.add_awb_cart && rowData.status !== "PO CREATED"
                    ? ( <CartIcon className={ classes.materialIcon } onClick={(events) => props.checkAirwayBillIsInTheCart(rowData.number, rowData.code, rowData.version) } />)
                    : ( <CartIcon className={ classes.disabledIcon } /> )
                  }
                </Tooltip>
                <Tooltip title="Remove from list">
                  <DeleteIcon className={ classes.materialIcon } onClick={(events) => props.deleteAwb(rowData.code, rowData.number) } />
                </Tooltip>
              </span>;
            }
          }
        ]}

        data = { props.awbs }

        options = {{
          paging: false,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15,20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  )
}

export default withStyles(styles)(Awbs);